"use client";

import { signIn } from "next-auth/react";
import { useSearchParams } from "next/navigation";
import { useRef, useState } from "react";
import LoginComponent from "@/components/templates/login";
import { requestMagicLink } from "@/actions/auth";
export default function LoginPage({
  turnstileSiteKey
}) {
  const [loading, setLoading] = useState(false);
  const [emailLoading, setEmailLoading] = useState(false);
  const searchParams = useSearchParams();
  const queryErrorMessage = searchParams.get("error");
  const [errorText, setErrorText] = useState(queryErrorMessage ?? undefined);
  const [successText, setSuccessText] = useState();
  const [magicLinkEmail, setMagicLinkEmail] = useState("");
  const [turnstileToken, setTurnstileToken] = useState("");
  const turnstileRef = useRef(null);
  const handleGoogleLogin = async () => {
    setLoading(true);
    try {
      await signIn("google");
    } catch (error) {
      const errorMessage = error instanceof Error ? error.message : "Unknown error";
      setErrorText(errorMessage);
      setLoading(false);
    }
  };
  const handleGitHubLogin = async () => {
    setLoading(true);
    try {
      await signIn("github");
    } catch (error_0) {
      const errorMessage_0 = error_0 instanceof Error ? error_0.message : "Unknown error";
      setErrorText(errorMessage_0);
      setLoading(false);
    }
  };
  const handleMagicLink = async email => {
    setEmailLoading(true);
    setErrorText(undefined);
    setSuccessText(undefined);
    try {
      const result = await requestMagicLink(email, turnstileToken);
      if (result.success && result.directToken) {
        // Trusted-device fast-path: skip the email roundtrip and sign in
        // directly. The 2FA gate still applies — the middleware/page checks
        // will redirect to /auth/verify-2fa after the session is created.
        await signIn("magic-link", {
          token: result.directToken,
          callbackUrl: "/"
        });
        return;
      }
      if (result.success) {
        setSuccessText("Check your email for a sign-in link.");
      } else {
        setErrorText(result.error);
      }
    } catch (error_1) {
      const errorMessage_1 = error_1 instanceof Error ? error_1.message : "Unknown error";
      setErrorText(errorMessage_1);
    } finally {
      setEmailLoading(false);
      // Turnstile tokens are single-use; reset the widget so a retry mints a
      // fresh one rather than re-submitting a now-spent token.
      turnstileRef.current?.reset();
      setTurnstileToken("");
    }
  };
  return <LoginComponent errorText={errorText} successText={successText} loading={loading} emailLoading={emailLoading} handleGoogleLogin={handleGoogleLogin} handleGitHubLogin={handleGitHubLogin} handleMagicLink={handleMagicLink} magicLinkEmail={magicLinkEmail} onMagicLinkEmailChange={setMagicLinkEmail} turnstileSiteKey={turnstileSiteKey} turnstileRef={turnstileRef} turnstileToken={turnstileToken} onTurnstileSuccess={setTurnstileToken} onTurnstileExpire={() => setTurnstileToken("")} />;
}